import { VISUAL_ITEMS } from "./constants";

export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);

export function setPath(obj, path, value) {
  const [head, ...rest] = path.split(".");
  if (!rest.length) return { ...obj, [head]: value };
  return { ...obj, [head]: setPath(obj?.[head] || {}, rest.join("."), value) };
}

export function nextNumber(list, prefix) {
  const nums = (list || []).map((x) => parseInt(String(x.numero || x.nome || "").replace(/\D/g, ""), 10)).filter((n) => !Number.isNaN(n));
  return `${prefix}${(nums.length ? Math.max(...nums) : 0) + 1}`;
}

export const emptyXYZ = () => ({ x: "", y: "", z: "" });

export const newPoint = (list, extra = {}) => ({
  id: uid(), numero: nextNumber(list, "P"), descricao: "", localizacao: "", lado: "",
  ref: emptyXYZ(), found: emptyXYZ(), nominal: "", encontrada: "", tolerancia: "", observacao: "", ...extra,
});

export const newAnomaly = (list) => ({
  id: uid(), numero: nextNumber(list, "A"), tipo: "", localizacao: "", ponto_referencia: "",
  orig: emptyXYZ(), found: emptyXYZ(), tolerancia: "", sentido: "", gravidade: "", observacao: "",
});

export const newDiagonal = (list) => ({ id: uid(), nome: nextNumber(list, "D"), ponto_inicial: "", ponto_final: "", medida: "", referencia: "" });

export function visualList(stored) {
  const map = Object.fromEntries((stored || []).map((v) => [v.item, v]));
  return VISUAL_ITEMS.map((item) => ({ item, status: "", obs: "", ...(map[item] || {}) }));
}

export const EDITABLE = ["status", "vehicle", "visual", "reference", "points", "axles", "diagonals", "rails", "anomalies", "drawings", "analysis", "laudo", "signature"];

export function hashInputs(insp) {
  const s = JSON.stringify([insp.vehicle, insp.reference, insp.points, insp.axles, insp.diagonals, insp.rails, insp.anomalies, insp.visual]);
  let h = 5381;
  for (let i = 0; i < s.length; i += 1) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  return String(h >>> 0);
}

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
};

export const fmtDay = (v) => {
  if (!v) return "—";
  const [y, m, d] = String(v).split("-");
  return d ? `${d}/${m}/${y}` : v;
};
